export default __webpack_public_path__ + "static/media/ind2.2224eaec.jpg";